import { parseBoldEntries } from "./parse-entries";
import { asCost, asString, normalizeRisk, normalizeStringArray } from "./parse-properties";
import type { Actor, ExternalSystem } from "./types";

function extractSubsection(body: string, name: string): string {
  const lines = body.split("\n");
  const lower = name.toLowerCase();
  const out: string[] = [];
  let collecting = false;
  for (const line of lines) {
    const h3 = line.match(/^###\s+(.+?)\s*$/);
    if (h3) {
      if (collecting) break;
      if ((h3[1] ?? "").trim().toLowerCase() === lower) {
        collecting = true;
        continue;
      }
    }
    if (collecting) out.push(line);
  }
  return out.join("\n");
}

export function parseSystemContext(sectionBody: string): {
  actors: Actor[];
  externalSystems: ExternalSystem[];
} {
  const actorsBody = extractSubsection(sectionBody, "Actors");
  const externalBody = extractSubsection(sectionBody, "External Systems");

  const actors: Actor[] = parseBoldEntries(actorsBody).map((entry) => {
    const props = entry.properties;
    const type = props.type === "system" ? "system" : "person";
    const { label, headline, description, why, type: _t, ...rest } = props;
    return {
      id: entry.id,
      label: asString(label) ?? entry.id,
      headline: asString(headline),
      description: asString(description),
      why: asString(why),
      type,
      ...rest,
    };
  });

  const externalSystems: ExternalSystem[] = parseBoldEntries(externalBody).map((entry) => {
    const props = entry.properties;
    const { label, headline, description, why, type, url, cost, risk, tags, ...rest } = props;
    return {
      id: entry.id,
      label: asString(label) ?? entry.id,
      headline: asString(headline),
      description: asString(description),
      why: asString(why),
      type: asString(type),
      url: asString(url),
      cost: asCost(cost),
      risk: normalizeRisk(risk),
      tags: normalizeStringArray(tags),
      ...rest,
    };
  });

  return { actors, externalSystems };
}
